import React, { useState } from 'react';
import { StyledForms } from '@app/components/styled/form/Form';
import { FormSection } from '@app/components/styled/form/FormSection';
import { Button } from '@app/components';
import { Toggle } from '@app/components/form/Toggle';
import { FieldWithLabel } from '@app/components/styled/form/Label';
import { NumberInput } from '@app/components/form/NumberInput';
import { OrderModeSelect } from '@app/components/form/selects/features/OrderModeSelect';
import { Dropdown } from '@app/components/form/Dropdown';
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { PackSelect } from '@app/components/form/selects/features/PackSelect';
import { ILoyaltyLevel } from '@app/common';
import { PriceInput } from '@app/components/form/PriceInput';

const LevelForm = ({ index, remove }) => {
  const [isOpen, setIsOpen] = useState(false);

  const { formState: { errors } } = useFormContext();

  const error = Boolean(errors.levels?.[index]) ? "Veuillez vérifier les champs" : undefined;

  const level: ILoyaltyLevel = useWatch({
    name: `levels.${index}`
  });

  let label = `Palier ${index + 1}`;

  if (level.loyaltyPointsNeeded > 0) {
    label = `Palier ${level.loyaltyPointsNeeded} points`;
  }

  if (level.loyaltyPointsNeeded > 0 && level.pack) {
    label = `Palier ${level.loyaltyPointsNeeded} points (${level.pack.name})`;
  }

  return (
    <Dropdown
      isOpen={isOpen}
      handleOpen={setIsOpen}
      label={label}
      error={error}
      onDelete={() => remove(index)}>

      <NumberInput
        name={`levels.${index}.loyaltyPointsNeeded`}
        min={0}
        label="Nombre de points nécessaires" />

      <PackSelect
        name={`levels.${index}.pack`} />

    </Dropdown>
  )
}

export const LoyaltyForm = () => {
  const { append, remove, fields } = useFieldArray({
    name: 'levels',
  });

  const addLevel = () => {
    append({
      loyaltyPointsNeeded: null,
      packId: null,
    });
  }

  return (
    <StyledForms.Form>

      <FormSection.Section>
        <FormSection.Title>Informations générales</FormSection.Title>
        <FormSection.Content>

          <FieldWithLabel label="Programme fidélité actif">
            <Toggle
              name="disabled"
              options={[
                { title: "Oui", value: false },
                { title: "Non", value: true },
              ]} />
          </FieldWithLabel>

          <FieldWithLabel label="Points séparés par restaurant">
            <Toggle
              name="byShop"
              options={[
                { title: "Oui", value: true },
                { title: "Non", value: false },
              ]} />
          </FieldWithLabel>

          <OrderModeSelect
            name="orderModes"
            isMultiple />

        </FormSection.Content>
      </FormSection.Section>

      <FormSection.Section>
        <FormSection.Title>Informations avancées</FormSection.Title>
        <FormSection.Content>

          <NumberInput
            name="exchangeRateForOneEuro"
            label="Taux de conversion (1€ = ? points)"
            min={0} />

          <FieldWithLabel label="Arrondir le montant à l'euro supérieur (12,90€ = 13 pts)">
            <Toggle
              name="roundPointsUp"
              options={[
                { title: "Oui", value: true },
                { title: "Non", value: false },
              ]} />
          </FieldWithLabel>

          <NumberInput
            name="maxPoints"
            label="Nombre de points maximum"
            min={0} />

          <PriceInput
            name="minPrice"
            label="Montant (€) du panier minimum pour bénéficier du programme" />

          <NumberInput
            name="daysWithoutOrderUntilReset"
            label="Nombre de jours avant la remise à 0"
            min={0} />

          <FieldWithLabel label="Utilisable sur la commande en cours">
            <Toggle
              name="usableOnlyOnNextOrder"
              options={[
                { title: "Oui", value: false },
                { title: "Non", value: true },
              ]} />
          </FieldWithLabel>

          <FieldWithLabel label="Utilisable sur le logiciel de caisse">
            <Toggle
              name="isUsableOnPOS"
              options={[
                { title: "Oui", value: true },
                { title: "Non", value: false },
              ]} />
          </FieldWithLabel>

        </FormSection.Content>
      </FormSection.Section>

      <FormSection.Section>
        <FormSection.Title>Configuration des paliers</FormSection.Title>
        <FormSection.Content>
          {fields.map((field, index) => (
            <LevelForm
              key={field.id}
              index={index}
              remove={remove} />
          ))}

          <Button
            onPress={addLevel}
            title="Ajouter un palier"
            bordered
            grow
            large
            square
            smallText />
        </FormSection.Content>
      </FormSection.Section>

    </StyledForms.Form>
  );
};
